import type { PropsWithChildren } from "react";

import { swSettings } from "app/common/services/swSettings";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isNoTouch, isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { NotEnoughQuotaTooltip } from "../../components/NotEnoughQuotaTooltip";
import type { QuotaOperationState } from "../../types";

type Props = PropsWithChildren<{ quota: QuotaOperationState }>;

const NotEnoughQuotaTooltipContainer = ({ quota, children }: Props) => {
    return (
        <NotEnoughQuotaTooltip
            quota={quota.remaining}
            isAdmin={salesSettingsHelper.isAdmin()}
            isNoTouch={isNoTouch(swSettings)}
            isTrial={isTrial(swSettings)}
        >
            {children}
        </NotEnoughQuotaTooltip>
    );
};

export default NotEnoughQuotaTooltipContainer;
